import React from 'react'
import Option from './Option'
import {removeActionFromButton} from "../actions"
import {minimizeAction} from "../actions"
import {maximizeAction} from "../actions"
import {connect} from "react-redux"
import styled from 'styled-components'
import { StyledLi } from '../styled-components/components';
import { StyledOption, OptionText, OptionSelect } from '../styled-components/option-styling';
import {changeExecuteOn} from '../actions'

const StyledButtonAction = styled.li
`
    list-style-type:none;
    width:100%;
    border:1px solid #808080;
    margin:10px 0;
    padding-bottom:10px;

`

const Header = styled.div
`
    background:#3c3c3c;
    width:100%;
    margin-bottom:10px;
    width:100%;
    height:30px;
`

const HeaderButton = styled.button
`
  border-radius:0;
  background:#292929;
  border:0;
  color:#c8c8c8;
  width:30px;
  height:30px;
  font-size:25px;
  line-height:30px;
  margin:0;
  padding:0;
  cursor:pointer;
  margin-right:1px;
  float:left;
`
const HeaderTitle = styled.h1
`
    font-weight:bold;
    font-size:20px;
    text-transform:uppercase;
    margin:0 10px;
    line-height:30px;
    padding:0;
    float:left;
    display:block;
`
const ButtonAction = ({action, preset, buttonID, actionID, dispatch, option}) => {
    var options = []
    if (action.get('options')) {
        action.get('options').map((option, name) => {
                options.push(<Option key={name} optionType="action" preset={preset} optionName={name} option={option} buttonID={buttonID}
                                     actionID={actionID}/>
                )
                return true
            }
        )
    }

    return(<StyledButtonAction>
        <Header>
            <HeaderButton onClick={()=>(dispatch(removeActionFromButton(preset, buttonID , actionID)))}>x</HeaderButton>
            {action.get('isMinimized') ?
                <HeaderButton onClick={()=>(dispatch(maximizeAction(preset, buttonID, actionID)))}>+</HeaderButton>
                :
                <HeaderButton onClick={()=>(dispatch(minimizeAction(preset, buttonID, actionID)))}>-</HeaderButton>
            }

            <HeaderTitle>{actionID}</HeaderTitle>
        </Header>

        {!action.get('isMinimized') &&
        <ul>
            <StyledOption>
                <OptionText>Execute on:</OptionText>
                <OptionSelect onChange={(e)=>dispatch(changeExecuteOn(preset, buttonID, actionID, e.target.value))} value={option.get("executeOn")}>
                    <option value="0">Press</option>
                    <option value="1">Release</option>
                    <option value="2">Double Tap</option>
                    <option value="3">Double Tap Release</option>
                    <option value="4">Long Press</option>
                    <option value="5">Long Press Release</option>
                </OptionSelect>
            </StyledOption>
            {options}
        </ul>
        }
    </StyledButtonAction>)
}

const getCurrentOption = (actions, preset, buttonID, actionID, optionName) =>{
    return actions.present.get(preset).get(buttonID).get(actionID)
}

function mapStateToProps(state, props){
    return{
        option : getCurrentOption(state.buttonActions, state.preset, props.buttonID, props.actionID, props.optionName)
    }
}

export default connect(mapStateToProps)(ButtonAction)




